var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI1Airplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 42v11.63l5 4v3.89L38 59l-8 2.49v-3.87l5-4V42h-.13L15 46.78v-5.44l20-12.78V19c0-4.42 1.34-8 3-8s3 3.58 3 8v9.56l20 12.78v5.44L41.13 42H41z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/I1_Airplane.fa70d51e.svg";
export { SvgI1Airplane as ReactComponent };